import { compose, withProps } from 'recompose'
import { createWithLazyEntities } from '@infotech/lib-api-middleware'

import {
  TOIR_ISSUES_SCHEMA_NAME,
  toirIssuesApiActions,
  toirIssuesSelector,
  toirIssuesEntitiesSelector,
} from 'api/toirIssues'


export const toirIssuesDataPropName = `toirIssues`

const withToirIssues = createWithLazyEntities({
  entitiesSelector: toirIssuesEntitiesSelector,
  dataSelector    : toirIssuesSelector,
  schemaName      : TOIR_ISSUES_SCHEMA_NAME,
  fetchApiAction  : toirIssuesApiActions.fetch,
  dataPropName    : toirIssuesDataPropName,
})


export const toirIssueTransport = compose(
  withProps(({
    toirIssueId,
  }) => ({
    query: { query: `id==${toirIssueId}` },
  })),
  withToirIssues
)
